module.exports = __webpack_public_path__ + "img/windmill.5389f202.svg";